


export default function GetCanvasRelativeBounds(target: HTMLElement | null): {
  left: number;
  top: number;
  width: number;
  height: number;
} {
  if (target == null) return { left: -1, top: -1, width: -1, height: -1 };

  let bounds = target.getBoundingClientRect();

 
    let canvasRoot = document.querySelector(".v-page-root");

  let canvasBounds = canvasRoot?.getBoundingClientRect();

  if (canvasBounds) {
    let top = bounds.top - canvasBounds.top;
    let left = bounds.left - canvasBounds.left;

    return { left: left, top: top, width: bounds.width, height: bounds.height };
  } else {
    return {
      left: bounds.left,
      top: bounds.top,
      width: bounds.width,
      height: bounds.height,
    };
  }
}
